export default __webpack_public_path__ + "static/meet-the-principal-sr-katy-8447b7186a457b39fa65a326aa398a4d.png";